import { Form, Input } from "antd";

interface IAccountNumberFieldProps {
  onBlur: (fieldName: string) => void;
}
const AccountNumberField = ({ onBlur }: IAccountNumberFieldProps) => {
  return (
    <Form.Item
      style={{ flexGrow: 1 }}
      name="accountNumber"
      label={
        <div>
          Account Number <span className="light-span-text"> (Optional)</span>
        </div>
      }
      // rules={[
      //   ({ getFieldValue }) => ({
      //     validator(_, value) {
      //       if (!value) return Promise.resolve();
      //       if (!/^\d+$/.test(value)) {
      //         return Promise.reject(new Error("Only numbers are allowed"));
      //       }
      //       if (value.length !== 7) {
      //         return Promise.reject(
      //           new Error("Account Number must be 7 digits long")
      //         );
      //       }
      //       return Promise.resolve();
      //     },
      //   }),
      // ]}
    >
      <Input
        autoComplete="off"
        placeholder="Account Number"
        // maxLength={7}
        onBlur={() => onBlur("accountNumber")}
      />
    </Form.Item>
  );
};

export default AccountNumberField;
